import PhoneIcon from '@mui/icons-material/Phone';

import { useI18n } from '@openclassrooms/translations/I18nProvider';
import Typography from '@classify/react-core-components/Typography';
import Button from '@classify/react-core-components/Button';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import Stack from '@classify/react-core-components/Stack';
import Hyperlink from '@classify/react-core-components/Hyperlink';

export default function PagePhone({ onGoBack }: { onGoBack: () => void }) {
  const { translate, i18n } = useI18n();
  const { getLocalisationConfig } = useLocalisationConfig();

  const phoneNumber = String(getLocalisationConfig('contact.phone.number'));

  return (
    <>
      <Typography variant="h5" component="h1" sx={{ mb: 2 }}>
        {translate('support.global.contact_channel.call.title')}
      </Typography>

      <Stack spacing={4}>
        <Typography>{translate('support.global.contact_channel.call.subheading')}</Typography>

        <Stack flexDirection="row" gap={2}>
          <PhoneIcon />
          <Stack
            flexDirection="column"
            gap={1}
            sx={{ borderLeft: '1px solid black', borderLeftColor: 'layout.line.divider', pl: 2 }}
          >
            <Hyperlink href={`tel:${phoneNumber}`}>{phoneNumber}</Hyperlink>
            {i18n.country === 'FR' && (
              <Typography>
                {translate('support.global.contact_channel.call.opening_times.fr')}
              </Typography>
            )}
          </Stack>
        </Stack>

        <div>
          <Button onClick={onGoBack} variant="secondary">
            {translate('global.word.back')}
          </Button>
        </div>
      </Stack>
    </>
  );
}
